import templateUrl from './newsfeedMemberGroup.html';

export default function newsfeedMemberGroup(
  uppercaseFirstFilter,
  ConversationService,
  PersonaCollection
) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      members: '=',
      isEveryone: '=',
      type: '@',
      display: '@',
      manage: '@',
      userCanStartPrivateConversation: '<',
    },
    templateUrl,
    link($scope) {
      $scope.oneLabel = ` ${uppercaseFirstFilter(
        $scope.type === 'user' ? 'employee' : $scope.type
      )}`;
      $scope.otherLabel = `${$scope.oneLabel}s`;

      $scope.membersFilter = function membersFilter(member) {
        return (
          member.type === $scope.type || ($scope.type === 'group' && member.type === 'everyone')
        );
      };

      $scope.hasAccessToUser = PersonaCollection.hasAccessToUser;

      $scope.sendDirectMessage = (userId) => ConversationService.openConversation(userId);
    },
  };
}
